import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export default function PartnershipCTA() {
  const { t } = useLanguage();

  const infoItems = [
    {
      icon: 'ri-building-line',
      label: t('公司背景', 'Company Background', '会社背景'),
      placeholder: t('公司名稱、主要業務', 'Company name, main business', '会社名・主要業務'),
    },
    {
      icon: 'ri-team-line',
      label: t('主要客戶類型', 'Main Client Types', '主要クライアントタイプ'),
      placeholder: t('回收廠、品牌端、政府單位…', 'Recyclers, brand owners, government agencies…', 'リサイクル業者・ブランドオーナー・政府機関…'),
    },
    {
      icon: 'ri-links-line',
      label: t('合作想法', 'Cooperation Ideas', '協力のアイデア'),
      placeholder: t('技術導入、區域經銷、ESG 專案…', 'Technology implementation, regional distribution, ESG projects…', '技術導入・地域販売代理・ESGプロジェクト…'),
    },
  ];

  return (
    <section className="relative section-padding overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#F0FAF6] via-[#EBF4FF] to-[#F5F8FB]" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] opacity-50 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,184,148,0.14) 0%, transparent 65%)' }} aria-hidden="true" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] opacity-35 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(2,115,194,0.10) 0%, transparent 65%)' }} aria-hidden="true" />

      <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br from-brand-green to-brand-blue mb-6">
              <i className="ri-team-line text-white text-2xl"></i>
            </div>
            <h2
              className="font-bold text-neutral-dark mb-5"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
            >
              {t(
                '想成為聚量的技術導入夥伴或經銷夥伴？',
                'Want to Become a PolyQ Technology or Distribution Partner?',
                '聚量の技術導入パートナーまたは販売代理パートナーになりたいですか？'
              )}
            </h2>
            <p className="text-neutral-mid mb-8" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
              {t(
                '請留下您的公司背景、主要客戶類型與合作想法，我們將協助評估最適合的合作模式。',
                'Please share your company background, main client types, and cooperation ideas. We will help evaluate the most suitable cooperation model.',
                '会社背景・主要クライアントタイプ・協力のアイデアをお知らせください。最適な協力モデルの評価をお手伝いします。'
              )}
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-green text-white text-[1.0625rem] font-semibold hover:bg-brand-green-dark transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              {t('聯絡聚量團隊', 'Contact PolyQ Team', '聚量チームに連絡')}
            </Link>
            <div className="mt-8 flex flex-wrap gap-5">
              {[
                { icon: 'ri-award-line', text: t('台灣 · 日本 · 歐盟 · 美國專利', 'TW · JP · EU · US Patents', '台湾・日本・EU・米国特許') },
                { icon: 'ri-global-line', text: t('持續拓展國際市場', 'Continuously Expanding International Markets', '国際市場への継続的な拡大') },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2 text-neutral-mid text-[1rem]">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-brand-green`}></i>
                  </div>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-neutral-border p-7" style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.07)' }}>
            <p className="text-[1rem] font-semibold text-brand-green uppercase tracking-widest mb-6">
              {t('聯絡時請準備', 'Please Prepare When Contacting', 'ご連絡時にご準備ください')}
            </p>
            <div className="space-y-5">
              {infoItems.map((item, idx) => (
                <div key={idx} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-brand-green-light flex-shrink-0">
                    <i className={`${item.icon} text-brand-green text-xl`}></i>
                  </div>
                  <div>
                    <p className="font-semibold text-neutral-dark text-[1.0625rem] mb-0.5">{item.label}</p>
                    <p className="text-neutral-mid text-[1rem]">{item.placeholder}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 pt-5 border-t border-neutral-border flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-brand-green-light flex-shrink-0">
                <i className="ri-time-line text-brand-green text-xl"></i>
              </div>
              <p className="text-neutral-mid text-[1rem] leading-relaxed">
                {t(
                  '初步評估通常於 3 個工作天內回覆',
                  'Initial assessment usually replied within 3 business days',
                  '初期評価は通常3営業日以内にご返信いたします'
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
